import { IconButton, SoundHighIcon, SoundNoneIcon } from "@minervaproject/fds";
import React from "react";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { listenToBreakoutRoom, stopListeningToBreakoutRoom } from "shared/reducers/classroom";
import { BreakoutRoomType } from "shared/types";
import { classroomSelectors, localSelectors } from "store";

function ListenButton({
  breakoutRoom,
  showButtonText,
}: {
  breakoutRoom: BreakoutRoomType;
  showButtonText?: boolean;
}) {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const listeningBreakoutRoom = useAppSelector(
    classroomSelectors.selectListeningBreakoutRoomForCurrentUser(),
  );
  const isListeningToThisBreakoutRoom = listeningBreakoutRoom?.id === breakoutRoom.id;

  const handleListenToBreakoutRoom = () => {
    if (isListeningToThisBreakoutRoom) {
      dispatch(
        stopListeningToBreakoutRoom({ userId: currentUserId, breakoutRoomId: breakoutRoom.id }),
      );
      return;
    }
    dispatch(listenToBreakoutRoom({ userId: currentUserId, breakoutRoomId: breakoutRoom.id }));
  };

  return (
    <IconButton
      onClick={handleListenToBreakoutRoom}
      aria-label={`Listen To Breakout Group ${breakoutRoom.title}`}
    >
      {isListeningToThisBreakoutRoom ? (
        <>
          <SoundHighIcon width={16} height={16} color="white" />
          {showButtonText && (
            <span className="text-black-tint-70 body-xs bold ml1">Stop Listening</span>
          )}
        </>
      ) : (
        <>
          <SoundNoneIcon width={16} height={16} />
          {showButtonText && <span className="text-black-tint-70 body-xs bold ml1">Listen</span>}
        </>
      )}
    </IconButton>
  );
}

export { ListenButton };
